module.exports = __webpack_public_path__ + "static/media/banner_mas_informados_desktop.f3e505f3.png";